import React, { useState, useContext, useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { optionContext } from "../../../utils/context/optionContext";
import RangeSlider from "./RangeSlider";
import SingleSelect from "../../../components/Form/SingleSelect";
import QuickLink from "../../../components/MyBiye/QuickItems/Index";
import { Height } from '../../../components/OptionsData/HeightData/Heightdata'
 
const Index = () => {
  const { options } = useContext(optionContext);
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);

  /* ===== RANGE STATES ===== */
  const [ageRange, setAgeRange] = useState([25, 35]);
  const [heightRange, setHeightRange] = useState([
    0,
    Height.length - 1,
  ]);
  console.log(heightRange);
  
//   const [heightRange, setHeightRange] = useState([4.5, 7]);

  const [materialStatus, setMaterialStatus] = useState(null);
  const [religion, setReligion] = useState(null);
  const [motherTongue, setMotherTongue] = useState(null);

  const [religionOptions, setReligionOptions] = useState([]);
  const [motherTongueOptions, setMotherTongueOptions] = useState([]);

  useEffect(() => {
    if (!options?.settingFiled2) return;

    options.settingFiled2.forEach((item) => {
      if (item.label === "Religion") setReligionOptions(item.value);
      if (item.label === "Language") setMotherTongueOptions(item.value);
    });
  }, [options]);

  /* ===== SUBMIT ===== */
  const submitForm = (e) => {
    e.preventDefault();

    setLoading(true);

    navigate(
      `/search/results?page=1&limit=20&gender=male` +
        `&age1=${ageRange[0]}` +
        `&age2=${ageRange[1]}` +
        `&height1=${heightRange[0]}` +
        `&height2=${heightRange[1]}` +
        `&religion=${religion?.value || ""}` +
        `&materialStatus=${materialStatus?.value || ""}` +
        `&motherTongue=${motherTongue?.value || ""}`
    );

    setLoading(false);
  };

  return (
    <div className="container search-container">
      <div className="row">
        <QuickLink />

        <div className="col-12 col-lg-8 mx-auto">
          <div className="card border-0">
            <div className="card-body p-lg-4">
              <form onSubmit={submitForm}>
                {/* AGE SLIDER */}
                <RangeSlider
                  label="Age"
                  min={18}
                  max={60}
                  value={ageRange}
                  onChange={setAgeRange}
                />

                {/* HEIGHT SLIDER */}
                <RangeSlider
                  label="Height"
                  min={4.5}
                  max={7}
                  step={0.1}
                  unit="'"
                  value={heightRange}
                  onChange={setHeightRange}
                />

                {/* MARITAL STATUS */}
                <p>Marital status</p>
                <SingleSelect
                  options={[
                    { value: "", label: "Any" },
                    { value: "never married", label: "Never Married" },
                    { value: "divorced", label: "Divorced" },
                    { value: "annulled", label: "Annulled" },
                    { value: "widowed", label: "Widowed" },
                    { value: "married", label: "Married" },
                  ]}
                  value={setMaterialStatus}
                />

                {/* RELIGION */}
                <p>Religion / Community</p>
                <SingleSelect
                  options={religionOptions}
                  value={setReligion}
                />

                {/* MOTHER TONGUE */}
                <p>Mother tongue</p>
                <SingleSelect
                  options={motherTongueOptions}
                  value={setMotherTongue}
                />

                <div className="text-end mt-3">
                  <button
                    type="submit"
                    className="btn shadow-none"
                    disabled={isLoading}
                  >
                    {isLoading ? "Searching..." : "Search"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
